import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Pages that should NEVER be indexed by Google
const NOINDEX_PATHS = [
  "/dashboard",
  "/investor-dashboard",
  "/dashboard/investor",
  "/holdings",
  "/add-funds",
  "/withdraw-funds",
  "/withdraw",
  "/rental-income",
  "/referrals",
  "/referral",
  "/invite",
  "/profile-settings",
  "/security",
  "/history",
  "/kyc",
  "/payment-settings",
  "/my-bank-account",
  "/notification-settings",
  "/reset-password",
  "/transactions",
  "/my-community",
  "/login",
  "/signup",
  "/register",
  "/forgot-password",
  "/forgot-password-email",
  "/verify-reset-code",
  "/set-new-password",
  "/admin",
];

const CANONICAL_ORIGIN = "https://estatecoin.in";

export default function CanonicalTag() {
  const { pathname } = useLocation();

  useEffect(() => {
    // ── Canonical tag ──────────────────────────────────────────
    const canonicalUrl = `${CANONICAL_ORIGIN}${pathname === "/" ? "" : pathname}`;

    let canonicalEl = document.querySelector('link[rel="canonical"]');
    if (!canonicalEl) {
      canonicalEl = document.createElement("link");
      canonicalEl.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute("href", canonicalUrl);

    // ── Noindex for private/auth pages ─────────────────────────
    const isPrivate = NOINDEX_PATHS.some(
      (p) => pathname === p || pathname.startsWith(p + "/")
    );

    let robotsEl = document.querySelector('meta[name="robots"]');
    if (!robotsEl) {
      robotsEl = document.createElement("meta");
      robotsEl.setAttribute("name", "robots");
      document.head.appendChild(robotsEl);
    }
    robotsEl.setAttribute(
      "content",
      isPrivate ? "noindex, nofollow" : "index, follow"
    );
  }, [pathname]);

  return null;
}
